import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Navbar, Nav } from "react-bootstrap";
import {
  EntypoBackInTime,
  EntypoBowl,
} from "react-entypo-icons";
import "./RestaurantDashboard.css";
import bgImage from "../../images/bg_img.jpg";
import CustomNavbar from "../../components/navbar/Navbar";
import { strings } from "../../localization";
import { getBgImageUrl, getLoginValueFromStorage, navigatePage, ORG_ID, ROUTE_PREFIX, TABLE_ID } from "../../config";
import { primaryColor, primaryColorVariant1 } from "../../config/colors";
import Footer from "../../components/Footer/Footer";
import { withRouter } from "react-router-dom";

const Dashboard = ({match, location}) => {
  const {restaurantName} = match.params || {};
  const [isLoginEnabled, setIsLoginEnabled] = useState(false);
  console.log('DEBUG dashboard page in restaurantName', restaurantName);

  const handleAddFoodButton = () => {
    navigatePage(`/${ROUTE_PREFIX}${restaurantName}/${isLoginEnabled ? 'food-selection' : 'menu'}`);
  };

  const handleCurrentOrders = () => {
    navigatePage(`/${ROUTE_PREFIX}${restaurantName}/current-orders`);
  };

  const handlePastOrders = () => {
    navigatePage(`/${ROUTE_PREFIX}${restaurantName}/past-orders`);
  };

  useEffect(() => {
    setIsLoginEnabled(getLoginValueFromStorage())
  }, [])

  return (
    <div className="dashboard-root">
      {/* Header Section */}
      <CustomNavbar />

      {/* Main Content with Background */}
      <div
        className="dashboard-background"
        style={{
          backgroundImage: `url("data:image/png;base64,${getBgImageUrl()}")`,
        }}
      >
        {/* Mobile Bottom Buttons */}
        <Container className="bottom-buttons d-md-none">
          <Row className="gx-2 gy-3">
            {
              isLoginEnabled &&
              <Col xs={6}>
                <Button
                  onClick={handleCurrentOrders}
                  variant="dark"
                  className="w-100 py-3 d-flex align-items-center justify-content-center gap-2 rounded-pill dashboardBtn"
                >
                  <EntypoBowl style={{ fontSize: 18, color: primaryColor }} />
                  <span className="dashboardBtnFont">
                    {strings.current_orders}
                  </span>
                </Button>
              </Col>
            }
            <Col xs={isLoginEnabled ? 6 : 12}>
              <Button
                onClick={handleAddFoodButton}
                variant="dark"
                className="w-100 py-3 d-flex align-items-center justify-content-center gap-2 rounded-pill dashboardBtn"
              >
                <span class="material-icons-outlined" style={{color: primaryColor}}>menu_book</span>
                <span className="dashboardBtnFont">{strings.menu}</span>
              </Button>
            </Col>
            {
              isLoginEnabled &&
              <Col xs={12}>
                <Button
                  onClick={handlePastOrders}
                  variant="dark"
                  className="w-100 py-3 d-flex align-items-center justify-content-center gap-2 rounded-pill dashboardBtn"
                >
                  <EntypoBackInTime style={{ fontSize: 18, color: primaryColor }} />
                  <span className="dashboardBtnFont">{strings.past_orders}</span>
                </Button>
              </Col>
            }
          </Row>
        </Container>

          {/* Footer */}
      <Footer />
      </div>
    </div>
  );
};

export default withRouter(Dashboard);
